/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Rwerere 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Gacundura": ["Burindwa", "Gacundura", "Kanigo", "Karegamazi", "Moma", "Rugaragara", "Rugarambiro", "Sarambwe"],
  "Gashoro": ["Bisaga", "Cyapa", "Gashoro", "Kibuye", "Ngonya", "Rugezi", "Rwerere"],
  "Ruconsho": ["Buhore", "Gakenke", "Kamatengu", "Kinkware", "Mugera", "Ngoma", "Ruconsho"],
  "Rugari": ["Gacyamu", "Gatovu", "Mucaca", "Murambo", "Mushubi", "Tangata"]
};